module.exports = __webpack_public_path__ + "assets/picture.d2e18363.svg";